import pvdCrosstownWest01 from './pvd-crosstown-west-01.jpg';
import pvdCrosstownWest02 from './pvd-crosstown-west-02.jpg';
import pvdCrosstownWest03 from './pvd-crosstown-west-03.jpg';
import pvdCrosstownWest04 from './pvd-crosstown-west-04.jpg';
import pvdCrosstownWest05 from './pvd-crosstown-west-05.jpg';

export const pvdCrosstownWestPhotos = [
  pvdCrosstownWest01,
  pvdCrosstownWest02,
  pvdCrosstownWest03,
  pvdCrosstownWest04,
  pvdCrosstownWest05,
];

